import React, { useEffect } from 'react';

import { Header, Spacer, Text } from '@kueski-dev/kueski-design-system';

import GtmEvent from 'Utils/GoogleTagManagerEvent';

import { DOMAIN, FEATURE, LoggerFactory } from 'Services/Logger';
import { Container, FooterActions } from './Error.styles';
import { ErrorProps } from './Error.types';

import IconRequestError from './error.svg';

const logger = LoggerFactory.getLogger(DOMAIN.KUESKI);

export const Error: React.FC<ErrorProps> = ({
  title = 'Ocurrió un error',
  message = 'No logramos procesar tu solicitud. Algo falló, te recomendamos recargar la página.',
  icon = <IconRequestError />,
  children,
  reason,
}) => {
  useEffect(() => {
    logger.error(
      `ErrorComponent: ${reason || 'Unknown'}`,
      FEATURE.APP,
      { message, reason, title },
    );
    GtmEvent({
      event: 'kpay_request_error_screen_shown',
    });
  }, []);

  return (
    <Container>
      <article aria-label={title}>
        {icon}
        <Spacer $size="spacing06" />
        <Header $format="Title/Large/Bold" $align="center">
          {title}
        </Header>
        <Spacer $size="spacing04" />
        <Text $format="Body/Large/Regular" $color="textSecondary" $align="center">
          {message}
        </Text>
        <Spacer $size="tablet:spacing07" />
      </article>
      {children && (
      <FooterActions aria-label="Acciones">
        {children}
      </FooterActions>
      )}
    </Container>
  );
};
